export default __webpack_public_path__ + "static/media/02_DAIF_Services_04.c0dd0acf.mp4";